
























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { File, XvOrderResp_Order, XvDeleteFileReq_FileType, XvAddFilesReq, XvAddFilesReq_FileType, XvSetOrderStatusReq, InternalStatus } from '@/apiv3/index'
import auth from '@/auth'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import helpers from '@/helpers'
import VueUploadComponent from 'vue-upload-component'
import { FileStatus } from '@/api'

@Component({ components: { PulseLoader, VueUploadComponent } })
export default class XvOrderDone extends Vue {
  @Prop(String) id!: string

  public order!: XvOrderResp_Order
  public blocked = false
  public loaded = false
  public files: Array<VUFile> = []
  public workFiles: Array<File> = []

  $refs!: {
    upload: VueUploadComponent;
  }

  public inputFile (newFile: VUFile, oldFile: VUFile) {
    if (Boolean(newFile) !== Boolean(oldFile)) {
      this.$refs.upload.active = true
    }
  }

  public removeFileOrder (file: VUFile) {
    this.$refs.upload.remove(file)
  }

  public uploadChunk (): object {
    const res = {
      action: 'https://xvostov.net/api/v2/file',
      minSize: 1,
      maxActive: 3,
      maxRetries: 5
    }

    return res
  }

  mounted () {
    const id = helpers.getAmount(this.id)

    auth.adminClient().XvOrder({ id: BigInt(id) }).then((resp) => {
      if (resp.order) {
        this.order = resp.order
        this.workFiles = this.order.workFiles
        this.loaded = true
      }
    })
  }

  formatDate (val: string | undefined): string {
    return helpers.formatDate(val)
  }

  doneOrder () {
    if (this.order === undefined) {
      return
    }

    this.blocked = true

    const files: bigint[] = []

    this.files.forEach((_value: VUFile, index: number) => {
      const resp = this.$refs.upload.files[index.valueOf()].response as FileStatus
      files.push(BigInt(resp.id))
    })

    const id = BigInt(helpers.getAmount(this.id))

    const req: XvAddFilesReq = {
      ids: files,
      orderId: id,
      type: XvAddFilesReq_FileType.WORK
    }

    const reqStatus: XvSetOrderStatusReq = { id: id, status: InternalStatus.TO_PAY }

    auth.adminClient().XvAddFiles(req).then(() => {
      return auth.adminClient().XvSetOrderStatus(reqStatus)
    }).then(() => {
      this.$router.push('/adm/xvostov')
    }).finally(() => {
      this.blocked = false
    })
  }

  public getFileURL (file: File, ord: XvOrderResp_Order | null): string {
    return helpers.getXvFileURL(file, ord)
  }

  removeFile (fileId: bigint, fileIdx: number) {
    auth.adminClient().XvDeleteFile({ id: fileId, orderId: BigInt(helpers.getAmount(this.id)), type: XvDeleteFileReq_FileType.WORK }).then(() => {
      this.workFiles.splice(fileIdx, 1)
    })
  }
}
